import { render, staticRenderFns } from "./BaseActionableLinkDisplay.vue?vue&type=template&id=d054ce42&"
import script from "./BaseActionableLinkDisplay.vue?vue&type=script&lang=js&"
export * from "./BaseActionableLinkDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d054ce42')) {
      api.createRecord('d054ce42', component.options)
    } else {
      api.reload('d054ce42', component.options)
    }
    module.hot.accept("./BaseActionableLinkDisplay.vue?vue&type=template&id=d054ce42&", function () {
      api.rerender('d054ce42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/actionableLink/BaseActionableLinkDisplay.vue"
export default component.exports